export const API_URLS = {
  ORGANISATION_LIST: '/v1/accounts',
  TRANSACTION_LIST: '/transactions',
  GET_USER: '/users/me',
  UPDATE_CURRENT_USER: '/users/me',
  GET_USERS: '/users',
  LAST_SEVEN_DAYS_HOUR_TRANSACTION: '/dashboard/me/hours/last-7-days',
  USER_PARAMETERS: '/users/me/parameters',
  USER_SKILL: '/users/:userId/skill',
  TRANSACTION_TYPES: '/transaction-types',
  MY_WEEKLY_BUDGET: '/dashboard/me/weekly-budget',
  TRANSACTION_BY_ID: '/transactions/',
  CREATE_TRANSACTION: '/transactions',
  UPDATE_TRANSACTION: '/transactions/',
  NOTES_LIST: '/notes',
  NOTES_DETAILS: '/notes/',
  DELETE_NOTES_ATTACHMENT: '/notes/:id/attachment',
  CREATE_NOTES_ATTACHMENT: '/notes/:id/attachment',
  DELETE_NOTES: '/notes/',
  DELETE_TRANSACTION: '/transactions/',
  MATTERS_LIST: '/matters',
  MY_MATTERS_LIST: '/matters/my',
  SKILLS_LIST: '/skills',
  MATTER_PHASES_LIST: '/matters/:id/matter-phases',
  TRANSACTION_RESTRICTIONS: '/matters/:id/transaction-restrictions',
  TRANSACTION_UNIT_PRICE: '/transaction-unit-price',
  MATTER_PARAMETERS: '/matters/:id/parameters',
  TASKS_LIST: '/activities',
  CRITICAL_TASKS_LIST: '/activities/critical-activities',
  WORK_TIMES: '/work-times',
  TRANSACTION_POSTING_PERIOD: '/users/me/transaction-posting-periods',
  CREATE_TRANSACTION_POSTING_PERIOD: '/transaction-posting-periods/open-next',
  ACTIVITY_STATUSES: '/activity-statuses',
  CREATE_ACTIVITY_TRANSACTION: '/activities/:id/create-transaction',
  UPLOAD_PROFILE_PICTURE: '/users/me/avatar',
  CONFLICT_SEARCHES: '/conflict-searches',
  CONFLICT_CHECKS_COMPANY: '/companies/:id/conflict-checks',
  CONFLICT_CHECKS_PRIVATE_PERSON: '/private-persons/:id/conflict-checks',
  COMPANY_MATTER_REQUESTS: '/companies/:id/matter-requests',
  COMPANY_MATTERS: '/companies/:id/matters',
  PRIVATE_PERSON_MATTER_REQUESTS: '/private-persons/:id/matter-requests',
  PRIVATE_PERSON_MATTERS: '/private-persons/:id/matters',
  COMPANY_NOTES_LIST: '/companies/:id/notes',
  PRIVATE_PERSON_NOTES_LIST: '/private-persons/:id/notes',
  CREATE_CONFLICT_CHECK: '/conflict-checks',
  CREATE_MATTER_REQUEST: '/matter-requests',
  CUSTOMER_LIST: '/customers',
  COMPANY_MATTER_LIST: '/companies/:id/linked-matters',
  PRIVATE_PERSON_MATTER_LIST: '/private-persons/:id/linked-matters',
  FAVORITE: '/my-favorites',
  REMOVE_FAVORITE: '/remove-from-favorite',
  MATTER_PARTIES: '/matters/:id/parties',
  MATTER_REQUEST_PARTIES: '/matter-requests/:id/parties',
  MATTER_IDENTIFICATIONS: '/matters/:id/identifications',
  MATTER_REQUEST_IDENTIFICATIONS: '/matter-requests/:id/identifications',
  ALL_MATTER_REQUESTS: '/matter-requests',
  MY_MATTER_REQUESTS: '/matter-requests/my',
  MATTER_TRANSACTIONS: '/matters/:id/transactions',
  INVOICE_TRANSACTIONS: '/preliminary-invoices/:id/transactions',
  MATTER_EXPENSES: '/matters/:id/expenses',
  INVOICE_EXPENSES: '/preliminary-invoices/:id/expenses',
  EXPENSES: '/expenses',
  CREATE_PRELIMINARY_INVOICE_PERIODICAL: '/matters/:id/create-preliminary-invoice/periodical',
  CREATE_PRELIMINARY_INVOICE_UNTIL_DATE: '/matters/:id/create-preliminary-invoice/until-date',
  WORK_TIME_TYPES: '/work-time-types',
  MARK_ACTIVITY_AS_COMPLETED: '/activities/:id/mark-as-completed',
  OPEN_ACTIVITY: '/activities/:id/mark-as-open',
  LOGOUT: '/auth/app-logout',
  LOGIN: '/v1/auth/app-login',
  CSRF_TOKEN: '/auth/csrf-token',
  ACCOUNT_PROFILE: '/v1/accounts/profile',
  RELEASE_NOTES: '/v1/release',
  MATTER_TYPES_LIST: '/matter-types',
  LANGUAGES_LIST: '/languages',
  CURRENCIES_LIST: '/currencies',
  COUNTRIES_LIST: '/countries',
  BUSINESS_AREAS_LIST: '/business-areas',
};
export const API_URLS_ENTITY = {
  MATTER: '/matters',
  MATTER_REQUEST: '/matter-requests',
  CONFLICT_CHECK: '/conflict-checks',
  COMPANY: '/companies',
  PRIVATE_PERSON: '/private-persons',
  MY_BILLABLE: '/my-billable',
  PRELIMINARY_INVOICES: '/preliminary-invoices',
  MY: '/my',
  PAYERS: '/payers',
  SYSTEM: '/system',
  PARAMETERS: '/parameters',
  INFO: '/info',
  NOTIFICATIONS: {
    NOTIFICATION_FEED: '/subscribers/feed',
    COUNT_UNREAD: '/subscribers/feed/unread-count',
    CHANGE_UNREAD: '/notifications/change-unseen',
    CHANGE_MUTE_STATE: '/subscriber/settings',
    REGISTER_TOKEN: '/subscriber/push-token',
  },
};
